import SectionArticleWithColumns from './SectionArticleWithColumns';
export default SectionArticleWithColumns;
